import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/home/g/p/vision/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/g/p/vision/layouts/default.vue").then(m => m.default || m))
}